module.exports = __webpack_public_path__ + "img/img (39).3334a78d.png";